const awsmobile = {
  aws_project_region: 'us-west-2',
};

export default awsmobile;
